
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import isNil from 'lodash/isNil';

import Loading from '../../components/common/Loading';
import IfElseComp from '../../components/common/IfElseComp';

import AppNavigation from '../../components/app/AppNavigation';
import Analyze2Opsub from '../../components/analyze2opsub/Analyze2Opsub.state';

const classNames = mergeStyleSets({
    Analyze2OpsubPage: {
        height: '100vh',
        width: '100vw'
    },
    content: {
        paddingLeft: 16
    }
});

const Content = ({
    project
}) => {

    return (
        <Stack verticalFill>
            <AppNavigation pageId="analyze2opsub" project={project} />
            <Stack.Item grow>
                <Analyze2Opsub />
            </Stack.Item>
        </Stack>
    );
}

const Analyze2OpsubPage = ({
    project,
}) => {
    return (
        <Stack verticalFill className={classNames.IsknActualInfo}>
            <Stack.Item grow>
                <IfElseComp
                    cond={!isNil(project)}
                    trueComp={
                        <Content
                            project={project}
                        />
                    }
                    falseComp={<Loading />}
                />
            </Stack.Item>
        </Stack>
    );
}

export default Analyze2OpsubPage;
